import { useState } from "react";
import { addToCartCookie, clearCookie, isTokenValid } from "./Cookies";
import Swal from "sweetalert2";
import { AddToCartService } from "../services/MainScreen";
import {
  HOME_URL_LOCAL,
  LOGIN_URL_LOCAL,
  RETURNURLLOGIN_URL_LOCAL,
} from "./BaseUrl";
import { useNavigate } from "react-router-dom";

export default async function AddToCartFunc(
  id = Number,
  quantityState = Number,
  quantity = Number,
  setQuantity = function () {},
  location,
  navigate,
  setData
) {
  //   if (1 > quantity) {
  //     Swal.fire({
  //       text: `حداکثر تعداد مجاز ${quantity} می‌باشد.`,
  //       icon: "warning",
  //       confirmButtonText: "باشه",
  //     });
  //   } else {
  //     if (isTokenValid()) {
  //     } else {
  //       let response = addToCartCookie(id, 1, quantity);
  //       if (response.isSuccess) {
  //         Swal.fire({
  //           text: "محصول با موفقیت به سبد خرید اضافه شد.",
  //           icon: "success",
  //           confirmButtonText: "باشه",
  //         });
  //         quantity = quantity - 1;
  //       } else
  //         Swal.fire({
  //           text: response.message,
  //           icon: "warning",
  //           confirmButtonText: "باشه",
  //         });
  //     }
  //   }

  if (quantityState > quantity) {
    Swal.fire({
      text: `حداکثر تعداد مجاز ${quantity} می‌باشد.`,
      icon: "warning",
      confirmButtonText: "باشه",
    });
    if (setQuantity) setQuantity(1);
  } else {
    if (isTokenValid()) {
      // let response = addToCartCookie(id, quantityState, quantity);
      // if (response.isSuccess) {
      //   Swal.fire({
      //     text: "محصول با موفقیت به سبد خرید اضافه شد.",
      //     icon: "success",
      //     confirmButtonText: "باشه",
      //   });
      //   quantity = quantity - quantityState;
      // } else
      //   Swal.fire({
      //     text: response.message,
      //     icon: "warning",
      //     confirmButtonText: "باشه",
      //   });

      let response = await AddToCartService(id, quantityState);
      if (response.status === 401)
        return Swal.fire({
          icon: "warning",
          title: "هشدار!",
          text: "توکن شما منقضی شده! لطفا دوباره وارد سیستم شوید!",
          confirmButtonText: "فهمیدم!",
        }).then((result) => {
          if (result.isConfirmed) navigate(LOGIN_URL_LOCAL);
        });
      else if (response.status == 200) {
        const { items, id, is_finished, total } = response.result;
        setData((prevState) => ({
          ...prevState,
          user: {
            ...prevState.user,
            cart: {
              // ...prevState.user.cart,
              id: id,
              items: items,
              is_finished: is_finished,
              total: total,
            },
          },
        }));
        return Swal.fire({
          title: "افزودن به سبد",
          text: response.message,
          icon: "success",
          confirmButtonText: "فهمیدم!",
        });
      } else
        return Swal.fire({
          title: "خطا!",
          text: "هنگام برقراری ارتباط با مشکل مواجه شدید!",
          icon: "error",
          confirmButtonText: "فهمیدم!",
        });
    } else
      Swal.fire({
        icon: "warning",
        title: "هشدار!",
        text: "شما احراز هویت نکردید! ",
        confirmButtonText: "فهمیدم!",
      }).then((result) => {
        if (result.isConfirmed)
          navigate(RETURNURLLOGIN_URL_LOCAL(location.pathname));
      });
  }
}

export const handleLogout = (navigate) => {
  Swal.fire({
    icon: "info",
    title: "خروج از حساب",
    text: "آیا از خارج شدن حساب کاربری خود مطمئن هستید؟",
    focusConfirm: false,
    showCancelButton: true,
    confirmButtonText: "باشه",
    cancelButtonText: "لغو",
  }).then(async (result) => {
    if (result.isConfirmed) {
      clearCookie();
      window.location.href = HOME_URL_LOCAL;
    }
  });
};
